import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.secondary,
      paddingBottom: '10px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
